import React from "react";

import { css, keyframes } from "@emotion/css";
import BGLeft from "../../../img/png/home/step-one/bg-left.png";
import BGMiddle from "../../../img/png/home/step-one/bg-middle.png";
import BGRight from "../../../img/png/home/step-one/bg-right.png";
import Girl from "../../../img/png/home/step-one/girl.png";
import Googles from "../../../img/png/home/step-one/googles.png";
import AngleText from "../../../img/png/home/step-one/angle-text.png";
import AngleTextM from "../../../img/png/home/step-one/angle-text-m.png";

import Img1 from "../../../img/png/home/step-one/img-1.png";
import Img4 from "../../../img/png/home/step-one/img-4.png";
import Img2 from "../../../img/png/home/step-one/img-2.png";
import Img3 from "../../../img/png/home/step-one/img-3.png";
import Img5 from "../../../img/png/home/step-one/img-5.png";
import { desktop, laptop, tablet } from "../../../styles/breakpoints";
import { useIsMobile } from "../../../components/helpers/ScreenCheck";
import { useI18n } from "../../../i18n";

const StepOne = () => {
  const isDesktop = useIsMobile(1399);
  const { t } = useI18n();
  return (
    <div
      style={{
        position: "relative",
        background: "#FF6AFF",
        overflow: "hidden",
      }}
    >
      <div className={style.container}>
        <img src={BGRight} className="bg-right" alt="" />
        <div className="wrapper">
          <div className="content">
            <h5>{t("home_step1_step")}</h5>
            <h3>{t("home_step1_analyse")}</h3>
            <p>
              {t("home_step1_analyse_body1")}
              <br />
              <br />
              {t("home_step1_analyse_body2")}
            </p>
          </div>

          <div className="images">
            <img src={BGLeft} className="bg-left" alt="" />
            <img src={BGMiddle} className="bg-middle" alt="" />
            <img src={Girl} className="img-girl" alt="" />
            <img src={Googles} className="img-googles" alt="" />
            <img
              src={isDesktop ? AngleTextM : AngleText}
              className="img-text"
              alt=""
            />
          </div>
        </div>
        <span className="bg-laptop"></span>
      </div>
      <div className={style.slider}>
        <ul>
          <li>
            <img src={Img1} alt="" />
            <img src={Img2} alt="" />
            <img src={Img3} alt="" />
            <img src={Img5} alt="" />
            <img src={Img4} alt="" />
            <img src={Img1} alt="" />
            <img src={Img2} alt="" />
            <img src={Img3} alt="" />
            <img src={Img5} alt="" />
            <img src={Img4} alt="" />
          </li>
        </ul>
        <ul aria-hidden="true">
          <li>
            <img src={Img1} alt="" />
            <img src={Img2} alt="" />
            <img src={Img3} alt="" />
            <img src={Img5} alt="" />
            <img src={Img4} alt="" />
            <img src={Img1} alt="" />
            <img src={Img2} alt="" />
            <img src={Img3} alt="" />
            <img src={Img5} alt="" />
            <img src={Img4} alt="" />
          </li>
        </ul>
      </div>
    </div>
  );
};

const animation = keyframes({
  to: { transform: "translateX(-100%)" },
});

const style = {
  slider: css({
    marginTop: -335,
    overflowX: "clip",
    position: "relative",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: 100,
    gap: 20,

    ul: {
      listStyle: "none",
      flexShrink: 0,
      minWidth: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 0,
      margin: 0,
      padding: 0,
      animation: `${animation} 10s linear infinite`,

      li: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",
        gap: 20,

        img: {
          height: 233,
          width: "auto",
        },
      },
    },

    [desktop]: {
      marginTop: -270,
      ul: {
        li: {
          img: {
            height: 194,
          },
        },
      },
    },
    [laptop]: {
      marginTop: -240,
      ul: {
        li: {
          img: {
            height: 233,
          },
        },
      },
    },
    [tablet]: {
      marginTop: -220,
      ul: {
        li: {
          img: {
            height: 140,
          },
        },
      },
    },
  }),
  container: css({
    width: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center ",
    alignItems: "flex-start",
    height: 1000,

    h5: {
      color: "#000",
      fontFamily: "Syne",
      fontSize: 52,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "98%",
      marginBottom: 12,
    },
    h3: {
      color: "#000",
      fontFamily: "Syne",
      fontSize: 78,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "100%",
      marginBottom: 54,
      textTransform: "uppercase",
    },
    p: {
      color: "#000",
      fontFamily: "Inter",
      fontSize: 18,
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      letterSpacing: 0.36,
    },
    ".bg-right": {
      position: "absolute",
      top: 0,
      right: "-5%",
      width: "auto",
      height: "auto",
      zIndex: 0,

      "@media (max-width: 1700px)": {
        display: "none",
      },
    },
    ".wrapper": {
      width: "100%",
      position: "relative",
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "flex-start",
      marginTop: 100,
      paddingLeft: 40,
      paddingRight: 40,

      ".bg-middle": {
        position: "relative",
        height: "auto",
        width: 837.26,
        marginTop: "-15px",
        right: -100,
      },
      ".bg-left": {
        position: "absolute",
        left: -1050,
        width: "auto",
        height: "auto",
        top: -100,
        zIndex: 2,
      },
      ".img-text": {
        position: "absolute",
        right: 0,
        left: "59px",
        top: "70px",
        width: "auto",
        height: "auto",
        zIndex: 2,
      },
      ".img-googles": {
        position: "absolute",
        right: 0,
        left: "-0px",
        top: "160px",
        height: "auto",
        zIndex: 2,
        width: 87,
      },
      ".img-girl": {
        position: "absolute",
        right: 0,
        left: 200,
        top: 100,
        width: "auto",
        height: "auto",
        zIndex: 2,
      },
      ".images": {
        position: "relative",
      },
      ".content": {
        maxWidth: 461,
        zIndex: 3,
        display: "block",
        position: "relative",
        marginTop: 80,
      },
    },
    [desktop]: {
      height: 814,

      h5: {
        fontSize: 48,
        marginBottom: 12,
      },
      h3: {
        fontSize: 64,
        marginBottom: 42,
        lineHeight: "60.976px",
      },
      ".wrapper": {
        maxWidth: 1000,
        position: "relative",

        ".bg-middle": {
          height: 644,
          width: "auto",
        },
        ".bg-left": {
          left: "-800px",
          height: 814,
          top: "-80px",
        },
        ".img-text": {
          top: -20,
          left: -40,
        },
        ".img-googles": {
          top: "100px",
          left: 40,
          width: "86px",
        },
        ".img-girl": {
          top: 50,
          left: 150,
        },
        ".content": {
          marginTop: 40,
          maxWidth: 430,
          marginRight: "-100px",
        },
      },
    },
    [laptop]: {
      height: 1200,

      h5: {
        fontSize: 48,
        marginBottom: 12,
      },
      h3: {
        fontSize: 64,
        marginBottom: 42,
        lineHeight: "60.976px",
      },
      ".bg-right": {
        display: "block",
        width: 400,
      },
      ".bg-laptop": {
        position: "absolute",
        backgroundColor: "#000",
        height: 200,
        bottom: 0,
        width: "100%",
      },
      ".wrapper": {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "stretch",
        marginTop: 64.5,
        gap: 64.5,

        ".bg-middle": {
          marginTop: 100,
          height: 600,
          right: -80,
          position: "absolute",
        },
        ".bg-left": {
          top: 50,
          height: 800,
          right: 280,
          position: "absolute",
          left: "unset",
        },
        ".img-text": {
          top: 0,
          width: 159,
          left: "unset",
          right: 300,
        },
        ".img-googles": {
          top: 350,
          width: 159,
          left: "unset",
          right: 500,
        },
        ".img-girl": {
          top: 100,
          width: 168,
          left: "unset",
          right: 450,
        },
        ".images": {
          height: 700,
        },
        ".content": {
          maxWidth: 627,
          marginTop: 0,
          marginRight: 0,
        },
      },
    },
    [tablet]: {
      height: 1000,

      h5: {
        fontSize: 26,
        marginBottom: 8,
      },
      h3: {
        fontSize: 42,
        marginBottom: 20,
        lineHeight: "30px",
      },
      p: {
        fontSize: 15,
      },
      ".bg-right": {
        display: "block",
        width: 300,
      },
      ".wrapper": {
        paddingLeft: 20,
        paddingRight: 20,

        ".bg-middle": {
          marginTop: 100,
          height: 440,
          right: -80,
          position: "absolute",
        },
        ".bg-left": {
          top: 50,
          height: 600,
          right: 140,
          position: "absolute",
          left: "unset",
        },
        ".img-text": {
          top: 0,
          width: 159,
          left: "unset",
          right: 120,
        },
        ".img-googles": {
          right: 260,
          top: 220,
          width: 119,
        },
        ".img-girl": {
          top: 70,
          width: 168,
          left: "unset",
          right: 200,
        },
        ".content": {},
      },
    },
  }),
};

export default StepOne;
